module.exports = __webpack_public_path__ + "static/media/Pending.f59ebf2f.svg";